import base from "../../../base";

const userIsUploader = async (uid) => {
	const uploaders = await base.fetch(`uploaders`, { context: this });
	if (Object.keys(uploaders).includes(uid)) return true;
	return false;
};

export default userIsUploader;
